import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Exploration.vue'
import BCell from '../views/BCell.vue'
import Exploration from '../views/Exploration.vue'
import Inflammation from '../views/Inflammation.vue'
import References from '../views/References.vue'
import Glossary from '../views/Glossary.vue'
import Sitemap from '../views/Sitemap.vue'
import SearchResult from '../views/SearchResults.vue'
// import Welcome from '@/views/Welcome.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Home',
    },
  },
  {
    path: '/sitemap',
    name: 'sitemap',
    component: Sitemap,
    meta: {
      title: 'Sitemap',
    },
  },
  {
    path: '/exploration',
    name: 'exploration',
    component: Exploration,
    meta: {
      title: 'Exploration',
    },
  },
  {
    path: '/inflammation',
    name: 'inflammation',
    component: Inflammation,
    meta: {
      title: 'View Early Inflammation Activity',
    },
  },
  {
    path: '/b-cell',
    name: 'b-cell',
    component: BCell,
    meta: {
      title: 'B-Cell Activity in Neuroinflammation',
    },
  },
  {
    path: '/references',
    name: 'references',
    component: References,
    meta: {
      title: 'References',
    },
  },
  {
    path: '/glossary',
    name: 'glossary',
    component: Glossary,
    meta: {
      title: 'Glossary of terms',
    },
  },
  {
    path: "/search-results",
    name: "searchresults",
    component: SearchResult,
    // beforeEnter(to, from, next) {
    //   /* only allow access to 'results' route if users
    //   are at game end. otherwise, re-direct to home page.
    //   */
    //   if (router.app.$store.state.isGameEnd) {
    //     next();
    //   } else {
    //     next({ name: "home" });
    //   }
    // },
  },  
  // {
  //   path: '/welcome',
  //   name: 'welcome',
  //   component: Welcome,
  //   meta: {
  //     title: 'Welcome',
  //   },
  // }
]

const router = new VueRouter({
  mode:'history',
  base:'/diagnosis/early-symptoms/',
  routes,
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 50)
    })
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.name !== 'welcome' && router.app.$cookies.get('isHcp') !== 'true') {
//     next({name: 'welcome'});
//   } else {
//     next();
//   }
// })

router.afterEach((to) => {
  document.title = 'Early MS Symptoms – Novartis';
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", 'Diagnosis and symptoms of multiple sclerosis (MS): Explore the activity and potential effects of early inflammation in MS. Early MS Symptoms, early neuroinflammation, multiple organs');

  // Explicitly call pageview tracking
  router.app.$gtag.pageview({
    page_path: `${to.path}`,
  })
})

export default router

